module.exports = __webpack_public_path__ + "static/media/Cross_Icon.b5da6c64.svg";